import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGtm, trackPageView } from "@/lib/gtm";

const GtmTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGtm();
  }, []);

  useEffect(() => {
    // Wait a tick so the page <title> is updated before sending
    const t = setTimeout(() => trackPageView(location.pathname + location.search), 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};

export default GtmTracker;
